import { useState } from 'react';
import type { Component } from '../../schemas/validation';
import type { ComponentManagerState } from './types';

export const useComponentManagerState = (): ComponentManagerState => {
  const [components, setComponents] = useState<Component[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasInitiallyLoaded, setHasInitiallyLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [editingComponent, setEditingComponent] = useState<Component | null>(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isSavingEdit, setIsSavingEdit] = useState(false);
  const [isSaveToLibraryModalOpen, setIsSaveToLibraryModalOpen] = useState(false);
  const [componentToSave, setComponentToSave] = useState<Component | null>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [componentToDelete, setComponentToDelete] = useState<Component | null>(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState<string | null>(null);

  return {
    components,
    setComponents,
    isLoading,
    setIsLoading,
    hasInitiallyLoaded,
    setHasInitiallyLoaded,
    error,
    setError,
    editingComponent,
    setEditingComponent,
    isEditModalOpen,
    setIsEditModalOpen,
    isSavingEdit,
    setIsSavingEdit,
    isSaveToLibraryModalOpen,
    setIsSaveToLibraryModalOpen,
    componentToSave,
    setComponentToSave,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    componentToDelete,
    setComponentToDelete,
    isDeleting,
    setIsDeleting,
    deleteError,
    setDeleteError,
  };
};
